import React, { Component } from 'react';
import api from '../../services/api';
import './Usuario.css';

export default class Usuario extends Component {

    state = {
        _Usuario: [],
    }

    async componentDidMount() {
        const response = await api.get(`/datasnap/rest/tsm/reccpf("95673482787")`);
        this.setState({ _Usuario: response.data.result[0] });
        console.log(response.data.result[0]);
    }
    render() {
        return (
            <div className="conteiner">
                <h2>Dados do Usúario</h2>
                <table className="table table-striped table-dark">
                    <thead>
                        <tr>
                            <th scope="col">MATRÍCULA</th>
                            <th scope="col">NOME</th>
                            <th scope="col">FILIAL</th>
                            <th scope="col">SITUAÇÃO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state._Usuario.map(usuario => (
                            <tr key={usuario.MATRICULA}>
                                <th scope="row">{usuario.MATRICULA}</th>
                                <td>{usuario.NOME}</td>
                                <td>{usuario.CODFILIAL}</td>
                                <td>{usuario.SITUACAO}</td>
                            </tr>
                        ))}

                    </tbody>
                </table>
            </div>
        )
    }
}